<template>
  <div class="creek-shows-container">
    <creek-shows-nav :shows-nav-text="showsNavText" :page-selected="'all'"></creek-shows-nav>
    <div class="creek-shows-find">
      <input type="text" v-model="findTerm" placeholder="Find a Show" />
    </div>
    <div class="creek-shows">
      <creek-show :data-show="Show" v-for="Show in ShowsFiltered" :key="Show.id"></creek-show>
    </div>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import lang from '../lang/eng';

import CreekShowsNav from './ShowsNav';

export default {
  name: 'creek-page-shows-all',
  mixins: [mixins.routes],
  components: {
    'creek-shows-nav': CreekShowsNav,
  },
  data () {
    return {
      shows: null,
      findTerm: '',
      showsNavText: lang.schedule
    }
  },
  created () {
    this.fetchData();
  },
  computed:{
    ShowsFiltered: function(){
      if(this.findTerm){
        var findTermLowerCase = this.findTerm.toLowerCase();
        var showsToFilter = this.shows.slice(0);
        var showsThatAreFiltered = showsToFilter.filter(function (el) {
          var title = el.title.toLowerCase();
          return title.indexOf(findTermLowerCase) > -1;
        });
        return showsThatAreFiltered;
      }
      else{
        return this.shows;
      }
    }
  },
  methods: {
    fetchData () {
      //Get data from schedule if it's already been retrieved
      if (this.shows == null) {
        var _this = this;
        this.JSONP(this.Creek.config.content.baseURLForAPI+"/api/shows", null, function(err, jsonParsed) {
          _this.shows = jsonParsed;
        });
      }
      this.setTitle("All Shows");
      this.swapPageClass("shows-all");
    }
  }
}
</script>